package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px

val DateRangeContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.LG {
        Modifier
            .flexDirection(FlexDirection.Row)
            .columnGap(25.px)
            .rowGap(16.px)
    }
}

val DateSectionStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(5.px)
            .minWidth(0.px)
    }

    Breakpoint.LG {
        Modifier
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
            .minWidth(0.px)
    }
}
val DateLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .styleModifier {
                property("transition", "opacity 200ms ease")
            }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}